import React from "react";

import { DatePicker } from "antd";
import classNames from "classnames";

import WPInputHelperText from "../../packages/WPInputHelperText";
import WPInputLabel from "../../packages/WPInputLabel";

import { DATE_FORMATS } from "../../constants/global.constants";

import { combineClassNames } from "../../utils/appUtils";

import "./WPDatePicker.scss";

const WPDatePicker = ({
  label,
  style,
  value,
  onChange,
  required,
  className,
  disabled = false,
  format = DATE_FORMATS.MM_DD_YYYY,
  placeholder = DATE_FORMATS.MM_DD_YYYY,
  picker = "date",
  size = "middle",
  allowClear = true,
  disabledDate,
  containerClassName,
  wrapperClassName,
  dataTestId,
  helperText,
}) => (
  <div
    className={classNames("wp-date-picker-container", containerClassName)}
    style={style}
  >
    {label && (
      <WPInputLabel required={required} label={label} disabled={disabled} />
    )}
    <div
      className={combineClassNames("wp-date-picker-wrapper", wrapperClassName)}
    >
      <DatePicker
        value={value}
        onChange={onChange}
        disabled={disabled}
        format={format}
        placeholder={placeholder}
        allowClear={allowClear && !disabled}
        picker={picker}
        size={size}
        disabledDate={disabledDate}
        aria-label={label || "Date Picker"}
        className={combineClassNames("wp-date-picker", className)}
        getPopupContainer={() => document.body}
        data-test-id={dataTestId}
      />
      {helperText && <WPInputHelperText text={helperText} />}
    </div>
  </div>
);

export default WPDatePicker;
